export default "__VITE_ASSET__DyB85_0m__"